export interface SerializedError {
  name?: string;
  message: string;
  stack?: string;
  cause?: unknown;
}

export function serializeError(error: unknown): SerializedError | unknown {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
      cause: error.cause instanceof Error ? serializeError(error.cause) : error.cause
    };
  }
  if (typeof error === 'string') {
    return { message: error };
  }
  return error;
}
